<div class="auction-actions">
  <span [ngSwitch]="auctionStatus" *ngIf="!auctionData?.is_closed">
    <p *ngSwitchCase="'upcoming'">
      <timer [Mode]="'light'" type="date" (TimerEnded)="$event?OnReload('upcoming'):null" [time]="auctionData?.remaining_time" [startORend]="1"></timer>
    </p>
    <p *ngSwitchCase="'ongoing'">
      <timer  [class.timeExtended]="timeExtended"  *ngIf="auctionData?.end_at" (TimerEnded)="$event?OnReload('ongoing'):null"  [auctionData]="auctionData" [getRemainingFromSocket]="1"
      [Mode]="'light'" type="date" [time]="auctionData?.remaining_time" [startORend]="2" (RemainingTime)="$event?checkShowConfirmSold():null;getRemaining();">
        <span *ngIf="timeExtended" id="timeExtended">Time Extended</span>
      </timer>
    </p>

  </span>


  <div class="joined-auction pb-4">

    <div *ngIf="auctionData?.is_closed" class="winner">

      <div class="withWinner" *ngIf="auctionData?.winner_id">
        <div class="head">
          <h4>{{'Auction Item.The auction has ended' | translate}}</h4>
          <p>{{'items-requests.Item sold' | translate}}</p>
        </div>
        <div class="detailes row">
          <div class="leftSide col-6">
            <span>{{'Home.Auction' | translate}} <br>{{'items-requests.Winner' | translate}}</span>
            <img src="/assets/images/icons/winnerCup.svg" alt="winnerCup">
          </div>
          <div class="rightSide d-flex col-6">
            <div class="info-badge">
              <div class="badge-img rounded-circle">
                <img *ngIf="auctionData?.winner_id.image" [src]="auctionData?.winner_id?.image"
                  (error)='auctionData?.winner_id.image = ""'>
                <span *ngIf="!auctionData?.winner_id?.image">
                  {{auctionData?.winner_id?.firstname +" "+ auctionData?.winner_id?.lastname | shortName }}</span>
              </div>
              <div class="badge-text">
                <p>{{auctionData?.winner_id?.firstname +" "+ auctionData?.winner_id?.lastname |titlecase}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="withOutwinner" *ngIf="!auctionData?.winner_id">
        <div class="head">
          <h4>{{'Auction Item.The auction has ended' | translate}}</h4>
          <p>{{'items-requests.With No Winner' | translate}}</p>
        </div>
      </div>



      <!-- <p> Winner is {{auctionData?.winner.firstname}} {{auctionData?.winner.lastname}}</p>
      <p>Auction Ended With No Winner</p> -->
    </div>

    <!-- <div class="reserve_admin" *ngIf="!auctionData?.is_closed &&
       auctionData?.is_reserve && 
       auctionData?.remaining_minutes_for_reserve && 
      auctionStatus == 'end'">

      <div class="head">
        <h4>The auction has ended</h4>
        <p>Reserve price not met</p>
      </div>
      <div class="d-flex justify-content-center align-items-center" style="background-color: #fff;">
        <div class=" auction-badge w-auto">
          <div class="badge-img rounded-circle">
            <img *ngIf="LastBidder?.image" [src]="LastBidder?.image" (error)='LastBidder.image = ""'>
            <span *ngIf="!LastBidder?.image">
              {{LastBidder?.username| shortName }}</span>
          </div>
          <div class="badge-text text-left">
            <p class="head">Top Bidder</p>
            <p class="name">{{LastBidder?.username | titlecase }} </p>
          </div>
        </div>
      </div>

    </div> -->

    <div class="wallet-current">
      <div class="current-bid current-bid-admin">
        <p class="current-bid-txt">{{auctionData?.is_closed?("Auction Item.Final Bid"|translate):("Auction Item.Current bid"|translate)}}</p>
        <p class="current-bid-price"><span>{{"Auction Item.SR"|translate}}</span>
          {{auctionData?.is_closed?auctionData?.last_bidding:number}}</p>
        <ng-container *ngIf="auctionData?.is_reserve">
          <p class="current-bid-txt current-bid-last">{{"Auction Item.Reserveprice"|translate}}</p>
          <p class="current-bid-last-price"><span>{{"Auction Item.SR"|translate}}</span> {{auctionData?.reserve_price}}
          </p>
        </ng-container>


      </div>
    </div>

    <div class="time-start-txt"
      *ngIf="(auctionStatus == 'upcoming' || auctionStatus=='ongoing') && !auctionData?.is_closed">
      <p *ngIf="auctionStatus == 'upcoming'">
        {{ "Auction Item.YouCanBegin" | translate}}
        {{startDateTimer | dateUTC}}
        <ng-container *ngIf="auctionData?.end_at">
          {{ "Auction Item.at" | translate}}
          {{endDateTimer | dateUTC:'hh:mm A'}}
        </ng-container>
      </p>
      <!-- <p *ngIf="auctionStatus == 'ongoing'">
        {{ "Auction Item.auctionHasStarted" | translate}}
        {{endDateTimer | dateUTC:'hh:mm A'}}
        {{ "Auction Item.auctionHasStartedBut" | translate}}
      </p> -->
    </div>


    <div class="action-auction">


      <!-- <ng-container *ngIf="auctionStatus == 'ongoing' && !auctionData.is_closed">
        <button mat-button class="btnLight_fill edit-action" (click)="onEndAuction()">
          {{ "Auction Item.End Auction"| translate}}
        </button>
      </ng-container> -->

      <!-- Resrve price Actions from Admin [Start] -->

      <div class="reserve_admin_actions w-100"
        *ngIf=" auctionData?.is_reserve && !auctionData?.is_closed && showConfirmSold && auctionStatus == 'ongoing' && bidders.length">
        <!-- <p class="lable">Waiting for the top bidder to increase his/her bid</p>
        <div class="timer">
          {{countdownString}} <span>left</span>
        </div>

        <h4>OR</h4> -->
        <div class="btns w-100">
          <button mat-button class="btn_fill w-100" (click)="AdminConfirmSolid()"
            [appLoading]="loadingBtnRequest">{{"items-requests.Confirm sold"|translate}}</button>
          <!-- <button mat-button class="btnLight_fill w-100" (click)="AdminEndAuctionWithNoWinner()"
            [appLoading]="loadingBtnRequest">End auction - no
            winner</button> -->

        </div>
      </div>

      <!-- Resrve price Actions from Admin [End] -->

    </div>

  </div>
</div>